import { Component, ViewEncapsulation, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
declare var KTMenu: any;

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportComponent extends DestructorComponent implements OnInit, AfterViewInit {

    // Navigation tabs
    activeTab: string = 'arap';

    constructor(
      private router: Router
    ) {
      super();
    }

    ngOnInit(): void {
      // Set initial active tab based on current route
      this.setActiveTabFromRoute();
    }

    ngAfterViewInit(): void {
      // Initialize KTMenu instances for dropdown menus
      this.initializeMenus();
    }

    // Initialize KTMenu instances
    initializeMenus(): void {
      setTimeout(() => {
        if (typeof KTMenu !== 'undefined') {
          KTMenu.createInstances();
        }
      }, 100);
    }

    // Set active tab based on current route
    setActiveTabFromRoute(): void {
      const currentUrl = this.router.url;
      if (currentUrl.includes('/ar_ap')) {
        this.activeTab = 'arap';
      } else if (currentUrl.includes('/sales')) {
        this.activeTab = 'sales';
      } else if (currentUrl.includes('/pending_invoices')) {
        this.activeTab = 'pending';
      } else {
        this.activeTab = 'arap'; // default
      }
    }

    // Navigation tab methods
    setActiveTab(tab: string): void {
      this.activeTab = tab;

      // Navigate to the appropriate route
      switch (tab) {
        case 'arap':
          this.router.navigate(['/sales/report/ar_ap']);
          break;
        case 'sales':
          this.router.navigate(['/sales/report/sales']);
          break;
        case 'pending':
          this.router.navigate(['/sales/report/pending_invoices']);
          break;
        default:
          this.router.navigate(['/sales/report/ar_ap']);
      }
    }
}
